var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"errors"},_vm._l((_vm.errors),function(error,index){return _c('li',{key:index},[_c('error-icon',{attrs:{"level":error.level,"small":_vm.small}}),_c('message-renderer',{attrs:{"message":error.message,"small":_vm.small}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }